// client/src/utils/siteBrand.js — which site this is (Illinois or Florida) and how it looks.
// One codebase runs both; the owner asked for Florida to be yellow so the two apps are
// told apart at a glance. The server marks the HTML shell <html data-site="FL">
// (lib/seoMeta.js siteHead); without it (development) the hook asks /api/public/jurisdiction.
// No imports, so scripts/test-pwa.js can load this file by stripping `export`.
// Keep the colours in step with lib/brecApp.js SITE_BRANDING.

export const FLORIDA_BRAND = {
    code: 'FL',
    label: 'Florida',
    siteName: 'BREC Florida',
    shortName: 'BREC FL',
    barClass: 'bg-yellow-400 text-slate-800',       // #facc15 with dark slate text
    accentClass: 'bg-yellow-400 text-slate-900',
};

/** 'FL' or 'IL' (anything unknown counts as Illinois, the default site). */
export function normaliseSite(code) {
    return String(code || '').trim().toUpperCase() === 'FL' ? 'FL' : 'IL';
}

/** Florida's look, or null on Illinois (which stays exactly as it was). */
export function siteBrand(code) {
    return normaliseSite(code) === 'FL' ? FLORIDA_BRAND : null;
}

/** The site code the server wrote into the page, or null when it is not there. */
export function siteFromDocument(doc) {
    try {
        const v = doc && doc.documentElement && doc.documentElement.getAttribute('data-site');
        return v ? normaliseSite(v) : null;
    } catch {
        return null;
    }
}
